import store from '@/store/index'

export default {
  isAllowed: async function (resourceSlug, permissionSlug) {
    return await store.dispatch('user/isAllowed', resourceSlug, permissionSlug)
  },
}
